import React, { useEffect, useState } from 'react';
// import DateCurrent from './DateCurrent';
import logo from './images/SuperSeva_Logo_white.png'
import './Navbar.css';
import image3 from './images/icons8-user-64.png';
import unacadamy_logo from './images/unacadamy_logo.png'
import {Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
let allcorporate=[]

function Navbar(props) {  

  let history=useHistory()
  let [scheme, setscheme]=useState([])
  let [call_log_user, setget_call_log_user]=useState({})
  let [selected_scheme, setselected_sceme]=useState('')
 
  const fetscallScheme=()=>{
    console.log('testin============g',props.useserdetails.id)
    axios.get('/get_schemes_stamp_paper?user_id='+props.useserdetails.id).then((res)=>{
      console.log(res,'teesting============2')
      allcorporate=[]
      if(Array.isArray(res.data.data)){
        res.data.data.forEach(key=>{
          if(JSON.parse(key.id)===JSON.parse(props.useserdetails.corporate_id)){
            setselected_sceme(key.id)
          }
        })
        for(let i=0;i<props.useserdetails.corporate.length;i++){
          res.data.data.forEach(key=>{
            if(props.useserdetails.corporate[i].toLowerCase()===key.scheme_name.toLowerCase()){
              allcorporate.push({id:key.id, scheme_name:key.scheme_name, payment_mode:key.payment_mode})
            }
          })
        }
      }
      setscheme(res.data.data)
    })
  }
  console.log('props.useserdetails.roles', props.userRole)
  const get_call_log_user=()=>{
    axios.get('/get_call_log_user?user_id='+props.useserdetails.id).then((res)=>{
      if(res.data){
        if(res.data.length!==0){
          setget_call_log_user(res.data[0])
        }
      }
    })
  }

  
  const getdata=(ev)=>{
    let date_from=''
    if(ev){
      date_from=new Date(ev).toDateString()
    }
    return date_from
  }
  const gettime =(ev)=>{
    let time=''
    if(ev){
       time=new Date(ev).toLocaleTimeString('en',
      { timeStyle: 'short', hour12: true });
    }
    return time;
  }
  console.log('call_log_user',allcorporate, selected_scheme)     
  useEffect(()=>{
    fetscallScheme()
    get_call_log_user()
  }, [])
  console.log('props.useserdetails.corporate_id',props.useserdetails.id,'testing', props.useserdetails.corporate_id)


//   const scheme1=props.useserdetails.corporate_id;
//   if(scheme1==null){
//     return <div> Scheme not selected </div>
//   }
// else{
  return (
    <>

    
    <div className="Navbar flex-container">
    <div className="navbar1">
      {props.useserdetails.corporate_id===1119?   
      <a className="navbar-brand" href="/">
        <img src={unacadamy_logo} 
        alt="SuperSeva.png" 
        className="superseva-logo" 
        width="65%" 
         />
      </a>:
      <a className="navbar-brand" href="/">      
        <img src={logo} 
        alt="SuperSeva.png" 
        className="superseva-logo"              
       style={{
         width:'65%'
       }} />
      </a>    
      }
    </div>

    <div className="navbar2">
     
    </div>
    {/*
      <div className='navbar4'>
      {Object.keys(call_log_user).length!==0&&
          <>
          <div>
            <span>Created At: &nbsp;{getdata(call_log_user.created_at)}&nbsp; {gettime(call_log_user.created_at)}</span>
          </div>
          <div>
            <span>Last Login: &nbsp;{getdata(call_log_user.login_time)}&nbsp;{gettime(call_log_user.login_time)}</span>
          </div>
          <div>
            <span>Last Logout: &nbsp; {getdata(call_log_user.logout_time)}&nbsp;{gettime(call_log_user.logout_time)}</span>
          </div>
          </>
        }
        </div>
    */}
    <div className="navbar3" >
    <img src={image3}
      alt="UserProfile.png"                    
      className="user-profile"
      width="auto" 
      height="auto" />
      <div className="dropdown">
      
      <Button className="dropbtn" variant="warning" style={{
        background:'#1863be', border:0,
      }}><p className="pbutton" >{props.useserdetails.name}</p>
      <span style={{color:"white", marginLeft:"30px"}}>⌄</span></Button>
      <div className="dropdown-content">
      <div style={{flexDirection:'column'}}>
          {props.useserdetails.roles.length!==0&&
            <a type='button'>
              <span style={{fontSize:14}}>User Role: {props.userRole}</span>
            </a>
          }
        
      </div>

      {/* <div>
      <select value={selected_scheme} onChange={(scheme_sele=>{
        console.log(scheme_sele.target.value)
        axios.get('/update_scheme?corporate_id='+scheme_sele.target.value).then(res=>{
          console.log('updated')
          history.go(0)
        })
      })}>
        <option key='-1' value="" disabled>Selected Scheme</option>
        {Array.isArray(props.useserdetails.corporate)&&
          allcorporate.map((schemeval, i)=>{
        return(
             <option key={i} value={schemeval.id}>{schemeval.scheme_name}</option>
              )
        }
        )  
        }
        
        </select>
      </div> */}

   



   {/*     <div>
            {
              scheme.map((schemeval, i)=>{
                if(props.useserdetails.corporate_id===schemeval.id){   
                  return<a type='button'><span key={i} style={{fontSize:14}}>Scheme Name: {schemeval.scheme_name}</span></a>
                }
              })
            }
        </div>   */}


        <a type='button' onClick={()=>{
          axios.get('/getcalllogsid').then((resp)=>{
            if(resp){
              // console.log(resp)
               axios.get('/call_log_out?user_id='+props.useserdetails.id+'&call_log_in_id='+resp.data.text).then((res)=>{
                axios.get('/logout').then((res)=>{
                  history.replace('/')
                  history.go(0)
                })
              })

            }
          })
          
        }} >Log Out</a>
      </div>
    </div>
      
    </div>
    </div>
    </>
  );
      }
// }

export default Navbar;
